import React, { useEffect } from "react";
import { useState } from "react";
import { ReactComponent as EditIcon } from "assets/images/icons/Row_Edit_Action.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/Row_Delete_Actions.svg";

import { Button } from "primereact/button";
import StyleWrapper from "./style";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const DriverCard = ({ driver, allowActions, handleDriverRemove, handleDriverEdit, hideDriverEdit }) => {
  const [driverToEdit, setDriverToEdit] = useState();
  const [genderName, setGenderName] = useState("");
  const [t, i18n] = useTranslation();
  const currentLanguage = i18n.language;

  useEffect(() => {
    //     // console.log(driver.genderCode);
    if (!driver.genderCode) {
      setDriverToEdit(true);
    }
  }, []);

  return (
    <StyleWrapper>
      <div className="driver-card mb-4">
        <div className="col">
          <p className="m-0 d-none d-md-block">
            {currentLanguage == "en" ? "Full Name" : "الاسم الكامل"}
          </p>
          <p className="m-0 fm-bliss2-bold">{driver?.engFullName || driver?.araFullName}</p>
        </div>
        <div className="col">
          <p className="m-0 d-none d-md-block">
            {currentLanguage == "en" ? "Saudi ID/Iqama" : "الهوية الوطنية / الإقامة"}
          </p>
          <p className="m-0 fm-bliss2-bold">{driver?.IDNO}</p>
        </div>
        <div className="col">
          <p className="m-0 d-none d-md-block">
            {currentLanguage == "en" ? "Year of Birth" : "سنة الميلاد"}
          </p>
          <p className="m-0 d-none d-md-block fm-bliss2-bold">
            {moment(driver?.gregDob, "DD-MM-YYYY").format("YYYY")}
          </p>
        </div>
        <div className="col">
          <p className="m-0 d-none d-md-block">{currentLanguage == "en" ? "Gender" : "الجنس"}</p>
          <p className="m-0 d-none d-md-block fm-bliss2-bold">
            {driver?.genderCode === "1" || driver?.genderCode === "M" ? t("Male") : ""}
            {driver?.genderCode === "2" || driver?.genderCode === "F" ? t("Female") : ""}


          </p>
        </div>
        <div className="col">
          {allowActions && (
            <>
              {/* <Button
                onClick={() => setDriverToEdit(true)}
                className="p-button-rounded p-button-outlined edit p-0"
              >
                <EditIcon />
              </Button> */}
              <Button
                className="p-button-rounded p-button-outlined remove p-0  mx-2"
                onClick={() => handleDriverRemove(driver)}
              >
                <TrashIcon />
              </Button>
            </>
          )}

        </div>
      </div>
    </StyleWrapper>
  );
};

export default DriverCard;
